import { render, staticRenderFns } from "./ContentOnly.vue?vue&type=template&id=e5a2e934&"
import script from "./ContentOnly.vue?vue&type=script&lang=js&"
export * from "./ContentOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports